import * as React from "react"
import Box from "@mui/material/Box"
import BottomNavigation from "@mui/material/BottomNavigation"
import BottomNavigationAction from "@mui/material/BottomNavigationAction"
import WidgetsIcon from "@mui/icons-material/Widgets"
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber"
import LocalAtmIcon from "@mui/icons-material/LocalAtm"
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner"
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined"
import { useLocation, useNavigate } from "react-router-dom"
import { clearCookies, getCookie } from "../../utils/cookies"

export default function SimpleBottomNavigation() {
  const user = getCookie("usercode")
  const navigate = useNavigate()
  const location = useLocation()

  const value =
    location.pathname === "/main"
      ? 0
      : location.pathname === "/bets"
        ? 1
        : location.pathname === "/winning"
          ? 2
          : location.pathname === "/scan"
            ? 3
            : 0

  const logout = () => {
    clearCookies()
    navigate("/", { replace: true })
  }

  if (!user) return null

  return (
    <Box
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1200,
        borderTop: "1px solid #eceef2",
        backgroundColor: "#fff",
      }}
    >
      <BottomNavigation
        showLabels
        value={value}
        sx={{
          height: 56,
          backgroundColor: "#fff",
          "& .MuiBottomNavigationAction-root": {
            minWidth: 0,
            maxWidth: "none",
            color: "#9a9aa2",
            px: 0.5,
            py: 0.75,
          },
          "& .MuiBottomNavigationAction-root.Mui-selected": {
            color: "#8650e7",
          },
          "& .MuiBottomNavigationAction-label": {
            fontFamily: "Manrope, sans-serif",
            fontWeight: 700,
            fontSize: "0.62rem",
            mt: 0.2,
          },
          "& .MuiBottomNavigationAction-label.Mui-selected": {
            fontSize: "0.62rem",
          },
          "& .MuiSvgIcon-root": {
            fontSize: 21,
          },
        }}
      >
        <BottomNavigationAction
          label="Main"
          icon={<WidgetsIcon />}
          onClick={() => navigate("/main")}
        />
        <BottomNavigationAction
          label="Bets"
          icon={<ConfirmationNumberIcon />}
          onClick={() => navigate("/bets")}
        />
        <BottomNavigationAction
          label="Winning"
          icon={<LocalAtmIcon />}
          onClick={() => navigate("/winning")}
        />
        <BottomNavigationAction
          label="Scan"
          icon={<QrCodeScannerIcon />}
          onClick={() => navigate("/scan")}
        />
        <BottomNavigationAction
          label="Logout"
          icon={<ExitToAppOutlinedIcon />}
          onClick={logout}
        />
      </BottomNavigation>
    </Box>
  )
}
